import { BUYING_AGENT_URL } from "../.."
const VAS_URL = agent_id => BUYING_AGENT_URL+"/"+agent_id+"/vas";
export {VAS_URL}